import { SIZE } from '@app/constants'
import { SEPARATOR } from '@app/constants/separator'

import type { LntSelectOption, LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}

export const statusesOptions: LntSelectOption[] = [
  { label: 'согласование ДУК', value: 'DKC_APPROVAL' },
  { label: 'согласование СОАЦ', value: 'SOAC_APPROVAL' },
  { label: 'согласована', value: 'APPROVED' },
  { label: 'отклонена', value: 'REJECTED' }
]

export const taskTypesOptions: LntSelectOption[] = [
  { label: 'Рекомендации к изменению', value: 'RECOMMENDATION_MODIFICATION' },
  { label: 'Рекомендации к удалению', value: 'RECOMMENDATION_REMOVAL' }
]

export const executorOptions: LntSelectOption[] = [
  { label: 'Мои задачи', value: 'is_my_tasks' },
  { label: 'Задачи роли', value: 'tasks_by_role' }
]
